import { Scalars, Car } from '../../types/generated';
import { apiMutate } from '../../utils/mutation';
import { updateCarMutation } from '../../mutations/car';
import ServiceConfigs from '../../config';
import { useCarBook } from './index';

type UseCarType = ({
  carId,
}: {
  carId: Scalars['ID'];
}) => ({
  make,
  color,
  licenseNumber,
}: {
  make: string;
  color: string;
  licenseNumber?: string;
}) => Promise<Partial<Car>>;

const useUpdateCar: UseCarType = ({ carId }) => {
  const { data: carsBook, mutate: mutateCarsBook } = useCarBook();

  return variables =>
    apiMutate({
      mutation: updateCarMutation,
      variables: carId ? { carId, ...variables } : null,
      requestHeaders: { ...ServiceConfigs.getAuthorizationHeader() },
      handler: (res: any) => res,
    }).then(updatedCar => {
      const updatedCars = carsBook.map(car => (car?.id === updatedCar?.id ? updatedCar : car));
      mutateCarsBook([...updatedCars], false);
      return updatedCar;
    });
};

export default useUpdateCar;
